<template>
    <div>
        <div class="columns">
            <div class="column has-text-centered">
                <h1 class="has-text-white is-size-3">
                    COMPANY MANAGER
                </h1>
            </div>
        </div>
        <div class="columns">
            <div class="column">
                <section class="section">
                <div class="buttons is-pulled-right">
                    <button class="button is-success is-small" @click="getCompanies('active')">Active</button>
                    <button class="button is-info is-small" @click="getCompanies('all')">All</button>
                    <button class="button is-warning is-small" @click="getCompanies('inactive')">Unapproved</button>
                </div>
                </section>
            </div>
        </div>
        <div class="columns">
            <div class="column">
                <section class="section">
                    <b-table :data="companies" paginated :per-page="10" :current-page.sync="currentPage"
                        :pagination-simple="false" pagination-position="bottom" :loading="isLoading" striped>
                        <b-table-column field="first_name" label="Name" searchable width="40" v-slot="props">
                            {{ props.row.name }}
                        </b-table-column>
                        <b-table-column field="address" label="Address" width="40" v-slot="props">   
                            {{ props.row.address }}
                        </b-table-column>
                        <b-table-column field="date_created" label="Date Joined" sortable width="30" v-slot="props">
                            <span v-if="props.row.date_created" class="tag is-warning">
                                    {{ new Date(props.row.date_created).toLocaleDateString() }}
                            </span>
                        </b-table-column>
                        <b-table-column field="phone_number" label="Phone #" searchable width="40" v-slot="props">   
                            {{ props.row.phone_number }}
                        </b-table-column>
                        <b-table-column field="main_contact_email" label="Main Email" width="40" v-slot="props">   
                            {{ props.row.main_contact_email }}
                        </b-table-column>
                        <b-table-column field="id" label="Edit" width="40" v-slot="props">
                                <i @click="updateModal(props.row)" class="fas fa-edit has-text-dvogreen"></i>  
                        </b-table-column>
                    </b-table>
                </section>
            </div>
        </div>
    </div>
</template>

<script>
import { API  } from 'aws-amplify'
import { companyReader } from '../graphql/queries'
import UpdateCompany from './UpdateCompany.vue'
export default {
    data() {
        return{
            currentPage: 1,
            companies: [],
            isLoading: false
        }
    },
    methods: {
    async getCompanies(query_type) {
        this.isLoading = true

        try {
        const companyReturn = await API.graphql({
            query: companyReader,
            variables: {
                input: {
                    request_type: 'read_all',
                    query_type: query_type
                }
            }
        });
    this.companies = companyReturn.data.companyReader;
        } catch (e) {
                this.$buefy.notification.open({
                duration: 5000,
                message: `${e}`,
                position: 'is-bottom',
                type: 'is-danger',
                hasIcon: true
            })
        }
    this.isLoading = false;
    },
    updateModal(companyObject) {
            this.$buefy.modal.open({
                parent: this,
                component: UpdateCompany,
                hasModalCard: true,
                trapFocus: true,
                props:{
                    initCompanyObj: companyObject
                },
                events: {
                }
            })
        }    
    },
    mounted(){
        this.getCompanies('active');
    }

}
</script>

<style>

</style>